import React from "react";
import logo from "../logo/icon-512.png";

const NAV_ITEMS = [
  { name: "About us", href: "#about" },
  // { name: "Core Values", href: "#services" }, // hidden with CoreValuesSection
  { name: "Philosophy", href: "#philosophy" },
  { name: "Products", href: "#products" },
  { name: "Contact", href: "#contact" },
];

const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer className="relative bg-ink text-paper pt-16 pb-10 overflow-hidden">
      <div
        className="absolute -bottom-40 left-1/2 -translate-x-1/2 w-[42rem] h-[42rem] rounded-full blur-3xl opacity-15 pointer-events-none"
        style={{ background: "radial-gradient(circle,#7E6BCB,transparent 62%)" }}
      />
      <div className="relative z-10 max-w-6xl mx-auto px-5 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-10">
          <div className="max-w-xs">
            <div className="flex items-center gap-2.5">
              <img src={logo} alt="Yuvi Labs" className="w-8 h-8 rounded-lg" />
              <span className="font-display font-normal text-xl">Yuvi&nbsp;Labs</span>
            </div>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3 text-sm text-paper/60">
            {NAV_ITEMS.map((item) => (
              <a key={item.href} href={item.href} className="hover:text-rose transition">
                {item.name}
              </a>
            ))}
          </nav>
        </div>
        <div className="h-px w-full bg-white/10 my-9" />
        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
          <p className="text-sm text-paper/45 font-normal">© {year} Yuvi Labs and Technologies. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
